// extracted by mini-css-extract-plugin
export default {"toggleBox":"Toggle_toggleBox__zvA-b","mode":"Toggle_mode__cLCNc","toggle":"Toggle_toggle__lzoNk","circle":"Toggle_circle__7S1Ww","darkTheme":"Toggle_darkTheme__iYb5E"};